import { render } from "./GoodsQuoin.vue?vue&type=template&id=1de4643a&scoped=true"
import script from "./GoodsQuoin.vue?vue&type=script&lang=js"
export * from "./GoodsQuoin.vue?vue&type=script&lang=js"

import "./GoodsQuoin.vue?vue&type=style&index=0&id=1de4643a&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1de4643a"]])

export default __exports__